//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CFooter from "@/common/Footer";
export default{
  data(){
    return{
      pager:{
        page: '1',
        pageCount: '1',
      },
      parPage: '1',
      parCount: '4',
      listArrs : []
    }
  },
  components: {
    CFooter
  },
  mounted(){
    this.finaceList()
  },
  methods: {
    finaceList(){
      let data = 'cmd=gd_list&page='+this.parPage+'&count='+this.parCount;
      this.$http.post('https://api.abeiyun.com/www/gd.php',data).then(({data})=>{
        if(data.response==200){
          this.listArrs = data.msg
          this.listArrs = data.msg.content.map((item, index) => {
            let type,state
            switch (item.gd_type) {
              case 'domain':
                type = '域名';
                break;
              case 'vhost':
                type = '虚拟主机';
                break;
              case 'vps':
                type = '云服务器';
                break;
              case 'beian':
                type = '网站备案';
                break;
              case 'account':
                type = '账号与财务';
                break
            }
            switch (item.gd_state) {
              case '0':
                state = '待分配'
                break
              case '1':
                state = '处理中'
                break
              case '2':
                state = '已答复'
                break
              case '3':
                state = '已结束'
                break
            }
            return {
              id:item.id,
              content:item.gd_content,
              type:type,
              time:item.gd_time,
              state:state,
            }
          })
          this.pager.page= data.msg.curpage
          this.pager.pageCount = data.msg.allpage
        }
      })
    },
    pageNum(n,par){
      if(par=='up'){

        if(n>1){
          n = n-1;
          this.parPage = n
          this.parCount = '4';
          this.finaceList();
        }
      }else if(par=='down'){
        if(n<this.pager.pageCount){
          n = parseInt(n)+1;
          this.parPage = n
          this.parCount = '4';

          this.finaceList();
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/gongdan.vue